import axios from 'axios'

const state = () => ({
  fotos: []
})

const getters = {
  fotos(state) {
    return state.fotos
  }
}

const mutations = {
  SET_FOTOS(state, payload){
    state.fotos = payload
  },
  DELETE_FOTOS(state, id){
    state.fotos = state.fotos.filter((x) => x.id != id);
  },
  ADD_FOTOS(state, data){
    state.fotos.push(data);
  },
  EDIT_FOTOS(state, data){
    state.fotos = state.fotos.map((vm)=>{
      if(vm.id == data.id){ return data}
      else{ return vm }
    })
  }
}

const actions = {
  getFotos({commit}){
    axios.get('https://api.geomalaka.uz/api/main/fotogalery/')
      .then((res)=>{
        commit("SET_FOTOS", res.data)
        // this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  getFotosId({commit}, id){
    axios.get(`https://api.geomalaka.uz/api/main/fotogalery/${id}/`)
      .then((res)=>{
        commit("SET_FOTOS", res.data)
        this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  deleteFotos({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/main/fotogalery/${id}/`)
      .then((res)=>{
        commit("DELETE_FOTOS", id)
        this._vm.$toast('Deleted', {type: 'success'})
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  addFotos({commit}, payload){
    axios.post(`https://api.geomalaka.uz/api/main/fotogalery/`, payload)
      .then((res)=>{
        commit("ADD_FOTOS", res.data)
        this._vm.$toast(res.statusText, {type: 'success'});
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  editFotos({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/main/fotogalery/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_FOTOS", res.data)
        this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }

}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

